import { Permission } from "../../models/Permission";
import DocumentList from "../genericcrud/DocumentList";
const PermissionMaster = () => {
  return (
    <>{<DocumentList
      documentMeta={Permission}
      isModel={true} />}
    </>
  );
};

export default PermissionMaster;
